import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, vModelText as _vModelText, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-340adbec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "申請画面")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_8 = { style: {"width":"100%"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"17%"} })
], -1))
const _hoisted_10 = { style: {"height":"40px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請No.", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請日", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "ステータス", -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { style: {"width":"100%","margin-top":"-5px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"21%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} })
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "ｱﾄﾞﾚｽ＿申請者名", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請タイトル", -1))
const _hoisted_20 = { colspan: "3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "対応希望日", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請種別", -1))
const _hoisted_23 = { colspan: "2" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_27 = { colspan: "3" }
const _hoisted_28 = { class: "form-inline flex-container" }
const _hoisted_29 = {
  class: "form-group",
  style: {"width":"100%","margin-right":"1rem"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "参考：関連情報", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"75%"} })
], -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "ワンストップガイド", -1))
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "関連資料", -1))
const _hoisted_36 = { class: "osg-files-cell" }
const _hoisted_37 = ["href", "onClick"]
const _hoisted_38 = {
  key: 0,
  class: "sub1"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { key: 2 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "全データダウンロード", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "添付資料", -1))
const _hoisted_47 = {
  colspan: "3",
  class: "osg-files-cell"
}
const _hoisted_48 = { class: "file-upload" }
const _hoisted_49 = ["accept", "readonly"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 1,
  class: "sub1"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ダウンロード", -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, "補足（注意事項）")
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "対象AGコード", -1))
const _hoisted_57 = { colspan: "2" }
const _hoisted_58 = ["readonly"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "対象企業ID", -1))
const _hoisted_60 = ["readonly"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "対応担当者", -1))
const _hoisted_62 = ["readonly"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "カウネット営業担当", -1))
const _hoisted_64 = ["readonly"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "依頼内容")
], -1))
const _hoisted_66 = { colspan: "6" }
const _hoisted_67 = ["readonly"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "カウネット返信欄")
], -1))
const _hoisted_69 = { colspan: "6" }
const _hoisted_70 = ["readonly"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "内部メモ欄"),
  /*#__PURE__*/_createElementVNode("td", null, "※申請者には表示されません")
], -1))
const _hoisted_72 = { colspan: "6" }
const _hoisted_73 = ["readonly"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"70%"} })
], -1))
const _hoisted_75 = { style: {"text-align":"left"} }
const _hoisted_76 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!
  const _component_EmailAddressModal = _resolveComponent("EmailAddressModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("td", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.appNo), 1)
                  ]),
                  _hoisted_12,
                  _createElementVNode("td", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.appDate), 1)
                  ]),
                  _hoisted_13,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.applicationData.appStatusKbn) = $event)),
                      class: "form-control",
                      disabled: !_ctx.enableEdit
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_15))
                      }), 128))
                    ], 8, _hoisted_14), [
                      [_vModelSelect, _ctx.applicationData.appStatusKbn]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.appUser), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_19,
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.appTitle), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_21,
                  _createElementVNode("td", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.wishDate), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_22,
                  _createElementVNode("td", _hoisted_23, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.applicationData.appCategoryId) = $event)),
                      disabled: "true"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appCategoryList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_24))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.applicationData.appCategoryId]
                    ])
                  ])
                ]),
                (
              _ctx.applicationData.osgCategoryID ||
              _ctx.applicationData?.osgTempFileList.length > 0
            )
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("td", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("fieldset", null, [
                              _hoisted_30,
                              _createElementVNode("table", null, [
                                _hoisted_31,
                                _createElementVNode("tbody", null, [
                                  (_ctx.applicationData.osgCategoryID)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [
                                        _hoisted_33,
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_router_link, {
                                            class: "com_link1",
                                            to: `/${
                                _ctx.applicationData.osgDetailPath
                              }/categoryId/${
                                _ctx.applicationData.osgCategoryID
                              }/contentsId/${
                                _ctx.applicationData.osgContentsId
                              }/ismodal/${true}`,
                                            target: "_blank",
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (
                                _ctx.regLinkClick(
                                  `/${
                                    _ctx.applicationData.osgDetailPath
                                  }/categoryId/${
                                    _ctx.applicationData.osgCategoryID
                                  }/contentsId/${
                                    _ctx.applicationData.osgContentsId
                                  }/ismodal/${true}`
                                )
                              ))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.applicationData.osgContentsTitle), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["to"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.applicationData?.osgTempFileList.length > 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                                        _hoisted_35,
                                        _createElementVNode("td", _hoisted_36, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationData?.osgTempFileList, (tempFile) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: tempFile.rowNo,
                                              class: "osg-file-row"
                                            }, [
                                              _createElementVNode("a", {
                                                href: `/${tempFile.tempFilePath}`,
                                                class: "com_link1",
                                                target: "_blank",
                                                onClick: ($event: any) => (_ctx.regFileLinkClick(tempFile.tempFilePath))
                                              }, _toDisplayString(tempFile.tempFileName), 9, _hoisted_37),
                                              (tempFile.tempFileSize)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " (" + _toDisplayString(tempFile.tempFileSize) + ")", 1))
                                                : _createCommentVNode("", true),
                                              (tempFile.tempFileName)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 1,
                                                    href: "#",
                                                    class: "com_dl_button2 osg-file-row__btn",
                                                    onClick: _withModifiers(($event: any) => (
                                  _ctx.downloadFiles(tempFile.tempFileName)
                                ), ["prevent"])
                                                  }, _hoisted_41, 8, _hoisted_39))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.applicationData?.osgTempFileList.length > 0)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                                        _hoisted_43,
                                        _createElementVNode("td", null, [
                                          _createElementVNode("a", {
                                            href: "#",
                                            class: "com_dl_button1",
                                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.downloadFiles('')), ["prevent"]))
                                          }, _hoisted_45)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_46,
                  _createElementVNode("td", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      (_ctx.enableEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary btn-sm",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (
                    _ctx.onContentsFileUpload(_ctx.AppMgtConstants.TRIGGER_TEMP_FILE)
                  ))
                          }, " + "))
                        : _createCommentVNode("", true),
                      _createElementVNode("input", {
                        type: "file",
                        accept: _ctx.tempFileExtensions.join(','),
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                        ref: "tempFileInput",
                        style: {"display":"none"},
                        readonly: !_ctx.enableEdit
                      }, null, 40, _hoisted_49)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationData.appTempFileList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.rowNo,
                        class: "osg-file-row"
                      }, [
                        (_ctx.enableEdit)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-danger btn-sm",
                              onClick: ($event: any) => (
                    _ctx.onRemoveContentsFile(
                      item.rowNo,
                      _ctx.AppMgtConstants.TRIGGER_TEMP_FILE
                    )
                  )
                            }, " - ", 8, _hoisted_50))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(item.fileName) + " ", 1),
                        (item.tempFileSize)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_51, " (" + _toDisplayString(item.tempFileSize) + ")", 1))
                          : _createCommentVNode("", true),
                        (item.fileName && !item.isUpload)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              href: "#",
                              class: "com_dl_button2 osg-file-row__btn",
                              onClick: _withModifiers(($event: any) => (_ctx.downloadTempFiles(item.fileName)), ["prevent"])
                            }, _hoisted_54, 8, _hoisted_52))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _hoisted_55,
                _createElementVNode("tr", null, [
                  _hoisted_56,
                  _createElementVNode("td", _hoisted_57, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtTergetAg",
                      maxlength: "50",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.applicationData.targetAgCode) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_58), [
                      [_vModelText, _ctx.applicationData.targetAgCode]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_59,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtCompanyId",
                      maxlength: "20",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.applicationData.targetCompanyId) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_60), [
                      [_vModelText, _ctx.applicationData.targetCompanyId]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_61,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtOperateUser",
                      maxlength: "20",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.applicationData.operateUser) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_62), [
                      [_vModelText, _ctx.applicationData.operateUser]
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_63,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtKaunetUser",
                      maxlength: "20",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.applicationData.kaunetUser) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_64), [
                      [_vModelText, _ctx.applicationData.kaunetUser]
                    ]),
                    _createElementVNode("label", null, _toDisplayString(_ctx.applicationData.kaunetUser), 1)
                  ])
                ]),
                _hoisted_65,
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_66, [
                    _withDirectives(_createElementVNode("textarea", {
                      id: "txtMemo",
                      class: "resizable-textarea",
                      rows: "5",
                      maxlength: "1000",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.applicationData.appMemo) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_67), [
                      [_vModelText, _ctx.applicationData.appMemo]
                    ])
                  ])
                ]),
                _hoisted_68,
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_69, [
                    _withDirectives(_createElementVNode("textarea", {
                      id: "txtKaunetComment",
                      class: "resizable-textarea",
                      rows: "5",
                      maxlength: "1000",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.applicationData.kaunetComment) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_70), [
                      [_vModelText, _ctx.applicationData.kaunetComment]
                    ])
                  ])
                ]),
                _hoisted_71,
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_72, [
                    _withDirectives(_createElementVNode("textarea", {
                      id: "txtKaunetComment",
                      class: "resizable-textarea",
                      rows: "5",
                      maxlength: "1000",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.applicationData.kaunetMemo) = $event)),
                      readonly: !_ctx.enableEdit
                    }, null, 8, _hoisted_73), [
                      [_vModelText, _ctx.applicationData.kaunetMemo]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", null, [
              _hoisted_74,
              _createElementVNode("tbody", null, [
                _createElementVNode("td", _hoisted_75, [
                  (_ctx.enableEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        name: "btnSave",
                        class: "btn btn-footer btn-danger",
                        onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                      }, " 削除 "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_76, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
                  }, " 戻る "),
                  (_ctx.enableEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        name: "btnApplication",
                        class: "btn btn-footer btn-success",
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
                      }, " 登録/返信 "))
                    : _createCommentVNode("", true),
                  (_ctx.enableEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        name: "btnApplication",
                        class: "btn btn-footer-large btn-success",
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.sendEscalationMail && _ctx.sendEscalationMail(...args)))
                      }, " エスカレーション "))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop),
    (_ctx.showEmailModal)
      ? (_openBlock(), _createBlock(_component_EmailAddressModal, {
          key: 2,
          onOk: _ctx.handleEmailModalOk,
          onCancel: _ctx.handleEmailModalCancel
        }, null, 8, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}